import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { TrashIcon, EyeIcon } from "@heroicons/react/24/outline";

export const useTeamColumns = (handleDelete, handleView, isExamCenterAdmin) => {
  const [t] = useTranslation();

  return useMemo(
    () => [
      {
        Header: t("admin.team_name"),
        accessor: "name",
      },
      {
        Header: t("admin.region"),
        accessor: "region",
        Cell: ({ value }) => value?.name || "-",
      },
      {
        Header: t("team.school"),
        accessor: "school",
      },
      {
        Header: t("admin.exam_center"),
        accessor: "exam_center",
        Cell: ({ value }) => value?.name || "-",
      },
      {
        Header: t("admin.supervisor"),
        accessor: "team_members",
        Cell: ({ value }) => {
          const supervisor = value?.find(
            (member) => member.role === "SUPERVISOR"
          );
          if (!supervisor) return "-";
          const user = supervisor.user;
          return (
            <div className="text-sm">
              <p className="font-medium">
                {user?.first_name} {user?.last_name} {user?.middle_name}
              </p>
              {user?.email && (
                <p className="text-gray-600 text-xs">{user.email}</p>
              )}
              {user?.phone_number && (
                <p className="text-gray-600 text-xs">{user.phone_number}</p>
              )}
            </div>
          );
        },
      },
      {
        Header: t("admin.status"),
        accessor: "status",
        Cell: ({ value }) =>
          value === "DRAFT"
            ? t("team.draft")
            : value === "APPROVED"
            ? t("team.approved")
            : value,
      },
      {
        Header: t("admin.actions"),
        accessor: "uuid",
        Cell: ({ row }) => (
          <div className="flex gap-2">
            <Button
              Icon={EyeIcon}
              onClick={() => handleView(row.original)}
              color="primary"
            />
            {!isExamCenterAdmin && (
              <Button
                Icon={TrashIcon}
                onClick={() => handleDelete(row.original)}
                color="error"
              />
            )}
          </div>
        ),
      },
    ],
    [t, handleDelete, handleView]
  );
};
